import { createAction } from '@/utility/actions';

import { PROFILES_GET_LIST, PROFILES_CLEAN_LIST, PROFILES_LOGIN_AS_USER } from './_types.ts';

/**
 * Get Profiles list
 * @param {object} params
 */
export const getProfiles = createAction(PROFILES_GET_LIST);

/**
 * Clean Profiles list
 * @param {object} params
 */
export const cleanProfilesList = createAction(PROFILES_CLEAN_LIST);

/**
 * Login as profile user
 * @param {string} user_id
 */
export const loginAsProfileUser = createAction(PROFILES_LOGIN_AS_USER);

export default {
  getProfiles,
  cleanProfilesList,
  loginAsProfileUser,
};
